import { render, staticRenderFns } from "./InvestorProfiles.vue?vue&type=template&id=46d9e0f8&"
import script from "./InvestorProfiles.vue?vue&type=script&lang=js&"
export * from "./InvestorProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports